// src/TeamSelector.js
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTeam } from "./TeamContext";
import logo from "./logo/Logo-Viktoria-Mitte-3.png";

export default function TeamSelector() {
  const { selectTeam } = useTeam();
  const navigate = useNavigate();
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

  useEffect(() => {
    const fetchTeams = async () => {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        setError("No access token found. Please login.");
        setLoading(false);
        return;
      }

      try {
        const res = await fetch(`${API}/teams`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error("Failed to fetch teams");

        const data = await res.json();

        // Only teams starting with "Viktoria"
        setTeams(data.filter((t) => t.name.startsWith("Viktoria")));
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTeams();
  }, []);

  const handleTeamSelect = (team) => {
    selectTeam(team);
    navigate(`/teams/${team.id}`);
  };

  if (loading) return <p className="text-center mt-10">Loading teams...</p>;
  if (error) return <p className="text-center mt-10 text-red-500">{error}</p>;

  return (
    <div className="min-h-screen bg-gray-100 px-4 py-10">
      {/* Banner / Header */}
      <header className="bg-blue-800 text-white py-6 shadow-md rounded-b-2xl">
        <div className="flex flex-col items-center space-y-4">
          <img src={logo} alt="Logo" className="h-20 w-auto" />
          <h1 className="text-3xl font-bold text-center">
            Select Your Team
          </h1>
        </div>
      </header>

      {/* Team List */}
      <div className="w-full max-w-5xl mx-auto bg-white rounded-2xl shadow-lg p-6">
        {teams.length === 0 ? (
          <p className="text-center text-gray-500">No teams available</p>
        ) : (
          <ul className="space-y-4">
            {teams.map((team) => (
              <li
                key={team.id}
                className="w-full flex items-center border border-gray-200 rounded-lg px-6 py-4 bg-gray-50 shadow-sm hover:shadow-md space-x-6"
              >
                {/* Team name grows naturally */}
                <span className="text-lg font-medium text-gray-800 truncate flex-1 border border-gray-300 px-5 py-2 rounded">
                  {team.name}
                </span>

                {/* Button stays fixed and spaced nicely */}
                <button
                  onClick={() => handleTeamSelect(team)}
                  className="bg-blue-600 text-white px-5 py-1.5 rounded-lg hover:bg-blue-700 transition-colors text-sm font-semibold flex-shrink-0"
                >
                  Select
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
